class UserAccess {
    id: number;
    owner: OwnerAccessVM;
    selected: boolean;
    createWorkbooks: boolean;
    type: AccessTypeEnum;
    fieldId: number;
    value: any;
    fields: Array<FieldAccessVM>;

    constructor(data) {
        this.id = data?.id ?? 0;
        this.owner = new OwnerAccessVM(data?.owner);
        this.selected = data?.selected ?? false;
        this.createWorkbooks = data?.createWorkbooks ?? false;
        this.type = data?.type ?? AccessTypeEnum.None;
        this.fieldId = data?.fieldId ?? undefined;
        this.value = data?.value ?? undefined;
        this.fields = createInstances(FieldAccessVM, data?.fields ?? [])
    }
}
class OwnerAccessVM {
    id: number;
    name: string;
    loginName: string;
    organizationId: number;
    userProfileCreateWorkbooks: boolean;
    active: boolean;

    constructor(data) {
        this.id = data?.id ?? undefined;
        this.name = data?.name ?? undefined;
        this.loginName = data?.loginName ?? undefined;
        this.organizationId = data?.organizationId ?? undefined;
        this.userProfileCreateWorkbooks = data?.userProfileCreateWorkbooks ?? undefined;
        this.active = data?.active ?? true;
    }
}

class FieldAccessVM {
    id: number;
    name: string;
    type: DataTypeEnum;

    constructor(data) {
        this.id = data?.id ?? undefined;
        this.name = data?.name ?? undefined;
        this.type = data?.type ?? undefined;
    }
}

class UserGroupOrganizationVM {
    id: number;
    name: string;

    constructor(data) {
        this.id = data?.id ?? undefined;
        this.name = data?.name ?? undefined;
    }
}

enum AccessTypeEnum {
    None,
    Full,
    Restrict,
    Default
}
enum AccessControlTypeEnum {
    User,//editing by mapping
    Group,//editing by mapping
    MappingUser,//editing by user
    MappingGroup//editing by group
}